export const eraList = [
  { value: 'AD' },
  { value: 'M' },
  { value: 'T' },
  { value: 'S' },
  { value: 'H' },
  { value: 'R' },
]
